




































import {Component, Vue} from "vue-property-decorator";
import {auditTrailModule} from "@/store";
import VueJsonPretty from "vue-json-pretty";

@Component({
    components: {
        VueJsonPretty
    }
})

export default class AuditTrailTable extends Vue {
    private loading: boolean = false;

    headersEvent: any = [
        {text: "Id", value: "id"},
        {text: "Timestamp UTC", value: "timeStamp"},
        {text: "Action", value: 'action'},
        {text: "Benutzer", value: "appUser.displayName"}
    ];

    headersChange: any = [
        {text: "Id", value: "id"},
        {text: "Table", value: "tableName"},
        {text: "Operation", value: 'operation'},
        {text: "KeyValues", value: "keyValues"},
        {text: "OldValues", value: "oldValues"},
        {text: "NewValues", value: "newValues"}
    ];

    search: string = "";

    get auditEvents() {
        return auditTrailModule.auditEvents;
    }

    parse(data: string | undefined) {
        if (data !== undefined && data !== "") {
             return JSON.parse(data);
        }
        return "";
    }

    get isLoading() {
        return this.loading || auditTrailModule.loading;
    }

    async mounted() {
        await this.update();
    }

    async update() {
        await auditTrailModule.loadAll();
    }
}
